<template>
  <div
    class="flex flex-col items-center p-40 my-40 border rounded border-grey-300"
  >
    <div
      class="flex items-center justify-center rounded-full h-80 w-80 bg-sky-100"
    >
      <Icon
        iconClass="fas fa-exclamation-triangle text-sky-500"
        :style="{ fontSize: '48px' }"
      />
    </div>
    <h6 class="text-center pt-20">
      {{ errorTitle }}
    </h6>
    <p class="mt-20 text-center">
      {{ errorBody }}
    </p>
    <HMButton rounded="full" class="mt-20 w-full" @click="handleReturn()">
      {{ $t('common.return_to_login') }}
    </HMButton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    errorTitle: {
      type: String,
      default: undefined,
    },
    errorBody: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters('member', ['isAuthenticated']),
  },
  methods: {
    ...mapActions(['logout']),
    handleReturn() {
      if (this.isAuthenticated) {
        this.logout()
      } else {
        this.$router.push({ name: 'login' })
      }
    },
  },
}
</script>
